import { Alert, Button, Checkbox, FormField, Input, LiveRegion } from '@cloudscape-design/components';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import Header from '@cloudscape-design/components/header';
import SpaceBetween from '@cloudscape-design/components/space-between';
import React, { useEffect, useState } from 'react';
import { addNotification, addNotificationStatus, buildBreadcrumbItems, formatCurrency, formatPhone, getCookie, getUrlVersion, getUserType, isValidPhone, setData, setLoading, setParameters } from '../../../../commons/functions';
import { useGlobalState } from '../../../../context/GlobalStateContext';
import { CustomAppLayout } from '../../../layout';
import { useRouter } from '../../../router';
import { useStore } from '../../../store';
const _preserve = React.version;
//import { useStoreAdmin } from '../../../../context/useStoreAdmin';
import { mdiRefresh } from '@mdi/js';
import Icon from '@mdi/react';
import Copy from '../../../../../components/Copy';
import DPModal from '../../../../../components/DPModal';
import BadgeCustom from '../../../../../components/extras/BadgeCustom';
import Favorites from '../../../../../components/extras/Favorites';
import UserAvatar from '../../../../../components/extras/UserAvatar';
import SelectUser from '../../../../../components/selects/selectUser';
import SelectUserType from '../../../../../components/selects/selectUserTypes';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { btnIconForm, ItemCountry, ItemUser } from '../../../../../resources/types';




export const OPSPlanningUsersPage = () => {
    const { data, menu, parameters, RUT } = useGlobalState();


    //const storeAdmin = useStoreAdmin();


    const [userPickerModal, setUserPickerModal] = useState(false);


    const {
        actions: { makeHelpPanelHandler },
    } = useStore();
    const { navigate } = useRouter();

    const [user, setUser] = useState<ItemUser>();


    const params = new URLSearchParams(window.location.hash.split('?')[1]);

    useEffect(() => {
        handleGetData();
    }, [parameters.idUser]);




    const handleGetBalances = async () => {
        if (parameters.idUser > 0) {
            try {
                setLoading(true)
                const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'x-routing': '/private/admin/movements/balances/list',
                        'JWT': getCookie("JWT"),
                        //  
                    },
                    body: JSON.stringify({
                        idUser: parameters.idUser, limit: 30, orderBy: "dateBalance", order: "desc"
                    }),
                    //mode: 'no-cors'  // Bypasses CORS but limits the response
                });

                if (!response.ok) {
                    throw new Error(`HTTP error: ${response.status}`);
                }
                const dataWeb = await response.json();
                addNotificationStatus(dataWeb, setData);
                if (dataWeb.code == 0) {
                    setUser({ ...user, balances: dataWeb.balances })

                }
            } catch (error: any) {
                addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
            } finally {
                setLoading(false)
            }
        };
    }



    const handleGetData = async () => {
        if (parameters.idUser > 0) {
            try {
                setLoading(true)
                const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'x-routing': '/private/admin/users/get',
                        'JWT': getCookie("JWT"),
                        //  
                    },
                    body: JSON.stringify({
                        idUser: parameters.idUser,
                        groups: true,
                        charges: true,
                        isStudent: true
                    }),
                    //mode: 'no-cors'  // Bypasses CORS but limits the response
                });

                if (!response.ok) {
                    throw new Error(`HTTP error: ${response.status}`);
                }
                const dataWeb = await response.json();
                addNotificationStatus(dataWeb, setData);
                if (dataWeb.code == 0) {
                    if (dataWeb.user.dateBirth) {
                        //dataWeb.user.dateBirth = parseDotNetDate(dataWeb.user.dateBirth);
                    }
                    if (dataWeb.user.dateMember) {
                        //dataWeb.user.dateMember = parseDotNetDate(dataWeb.user.dateMember);
                    }

                    if (dataWeb.user) {
                        dataWeb.user.phone1 = formatPhone(dataWeb.user?.phone1);
                        dataWeb.user.phone2 = formatPhone(dataWeb.user?.phone2);
                        dataWeb.user.ICEPhone = formatPhone(dataWeb.user?.ICEPhone);

                        const userType = getUserType(dataWeb.user.idUserType, data);
                        if (dataWeb.user.idUserType) {
                            dataWeb.user.userTypeUT = userType.ut;
                            dataWeb.user.userTypeColor = userType.color;
                        }
                    }

                    setUser(dataWeb.user)

                    if (!dataWeb && !dataWeb.user) return
                    let updatedUser = { ...dataWeb.user };
                    if (isValidPhone(updatedUser.phone1)) {
                        updatedUser.phone1 = formatPhone(dataWeb.user?.phone1);
                    }
                    if (isValidPhone(dataWeb.user?.phone2)) {
                        updatedUser.phone2 = formatPhone(dataWeb.user?.phone2);
                    }
                    if (isValidPhone(dataWeb.user?.ICEPhone)) {
                        updatedUser.ICEPhone = formatPhone(dataWeb.user?.ICEPhone);
                    }
                    setUser(updatedUser);

                }
            } catch (error: any) {
                addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
            } finally {
                setLoading(false)
            }
        };
    }


    return (

        <CustomAppLayout
            toolsHide
            contentType="form"
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <>
                    <SpaceBetween direction="vertical" size="xs">


                        <Header

                            //info={<Link onClick={() => setHelpOpen(!helpOpen)}><Icon path={mdiHelpCircleOutline} size={1}></Icon></Link>}
                            actions={
                                <SpaceBetween direction="horizontal" size="xs">
                                    <SelectUser
                                        value={parameters.idUser}
                                        onConfirm={(detail) => {
                                            setUser(undefined)
                                            if (detail) {
                                                setParameters((prev: any) => ({
                                                    ...prev,
                                                    idUser: Number(detail.idUser)
                                                }));

                                            } else {
                                                setParameters((prev: any) => ({
                                                    ...prev,
                                                    idUser: 0
                                                }));


                                            }

                                        }} />
                                    {parameters.idUser > 0 && (<Button style={{ root: btnIconForm }} onClick={handleGetData}><Icon path={mdiRefresh} size={1} /></Button>)}

                                    <Favorites />
                                </SpaceBetween>
                            }
                        /*info={<Link variant="info">Info</Link>}*/
                        >
                            Ficha de socio
                        </Header>

                        {(!user) && (
                            <Alert>
                                Sin usuario seleccionado, realize una búsqueda para seleccionar un usuario, ya sea por nombre, apellido, email, RUT o móvil.
                            </Alert>
                        )}
                        {user && user.idUser > 0 && (
                            <SpaceBetween direction="vertical" size="l">
                                <Header
                                    actions={<>
                                        <SpaceBetween direction="horizontal" size="s">
                                            <Copy value={user?.idUser?.toString() || ""} />
                                            <UserAvatar idUser={user?.idUser || 0} width={35} />
                                        </SpaceBetween>
                                    </>}
                                    variant="h2"
                                    description={<>
                                        Saldo: {formatCurrency(user?.balance || 0, "CLP")} | 45 días: {formatCurrency(user?.balance45 || 0, "CLP")} | Últ acceso: {user.dateLastLogin !== "" ? user.dateLastLogin : "Nunca"}
                                    </>}
                                    info={<><BadgeCustom key={user?.userTypeUT} color={user?.userTypeColor || "grey"}>
                                        {user?.userTypeUT}
                                    </BadgeCustom>{user?.isDeleteUser === 1 && <BadgeCustom color="red">Eliminado</BadgeCustom>}</>}
                                >
                                    {user?.displayName}
                                </Header>
                                <SpaceBetween direction='vertical' size="s">
                                    <SpaceBetween direction='horizontal' size="s">
                                        <div style={{ maxWidth: 200 }}>
                                            <FormField

                                                label={<>{"RUT"}</>}
                                                info={<Copy showText={false} value={user?.RUT || ""} />}

                                            /*label={<>{"RUT"}<Link href={`#admin/users?idUser=${user?.RUT}`} external variant="primary" ></Link></>}*/
                                            >
                                                <Input value={user?.RUT || ""} readOnly />
                                            </FormField>
                                        </div>
                                        <div style={{ maxWidth: 200 }}>
                                            <FormField label="Apellidos">
                                                <Input value={user?.lastName || ""} readOnly />
                                            </FormField></div>
                                        <div style={{ maxWidth: 200 }}>
                                            <FormField label="Nombres">
                                                <Input readOnly value={user?.name || ""} />
                                            </FormField>
                                        </div>
                                    </SpaceBetween>
                                    <SpaceBetween direction='horizontal' size="s">
                                        <div style={{ maxWidth: 150 }}>
                                            <FormField label="Teléfono" constraintText="Formato 56XXXXXXXXX">
                                                <Input readOnly value={user?.phone1 || ""} />
                                            </FormField>
                                        </div>
                                        <div style={{ maxWidth: 200 }}>
                                            <FormField label="Email">
                                                <Input readOnly value={user?.email || ""} />
                                            </FormField></div>
                                        <div style={{ maxWidth: 200 }}>
                                            <FormField label="Email Alt." constraintText="Opcional">
                                                <Input readOnly value={user?.email2 || ""} />
                                            </FormField>
                                        </div>
                                        <div style={{ maxWidth: 200 }}>
                                            <FormField label="Nacionalidad">
                                                <Input value={data?.countries?.find((c: ItemCountry) => c.idCountry === user?.idCountry)?.country || ""} readOnly />
                                            </FormField>
                                        </div>
                                    </SpaceBetween>
                                    <SpaceBetween direction='horizontal' size="s">

                                        <div style={{ maxWidth: 200 }}>

                                            <FormField label="Fecha nacimiento"
                                                constraintText={user?.age ? `${user.age} años` : ""}
                                            >
                                                <DPModal readonly date={user?.dateBirth ? user.dateBirth : ""} />
                                            </FormField>
                                        </div>
                                        <div style={{ maxWidth: 200 }}>
                                            <FormField label="Fecha ingreso">

                                                <DPModal readonly date={user?.dateMember ? user.dateMember : ""} />
                                            </FormField>
                                        </div>
                                        <div style={{ maxWidth: 250 }}>
                                            <FormField label="Tipo de usuario">
                                                <SelectUserType readonly single={true} value={user?.idUserType} visible={true}
                                                />
                                            </FormField>
                                        </div>

                                        <div style={{ maxWidth: 150 }}>
                                            <FormField label="Estado">
                                                <Checkbox readOnly checked={user?.isActiveUser === 1}>{user?.isActiveUser === 1 ? "Activo" : "Inactivo"}</Checkbox>
                                            </FormField>
                                        </div>

                                    </SpaceBetween>
                                    <SpaceBetween direction='horizontal' size="s">

                                        {
                                            user?.studentCertification !== undefined && (
                                                <FormField label="Estudiante" constraintText="Vencimiento de justificación de beneficio">
                                                    <DPModal readonly date={user?.studentCertification ? user.studentCertification : ""} />

                                                </FormField>
                                            )
                                        }
                                    </SpaceBetween>

                                    <LiveRegion>
                                        <Alert
                                            type="error"
                                            header="Contacto ICE">
                                            <SpaceBetween direction='horizontal' size="s">
                                                <div style={{ maxWidth: 300 }}>
                                                    <FormField label="Nombre" constraintText="Persona a contactar en caso de emergencia">
                                                        <Input readOnly value={user?.ICEContact || ""} />
                                                    </FormField>
                                                </div>
                                                <div style={{ maxWidth: 150 }}>
                                                    <FormField label="Teléfono">
                                                        <Input readOnly value={user?.ICEPhone || ""} />
                                                    </FormField></div>
                                            </SpaceBetween>

                                        </Alert>
                                    </LiveRegion>

                                </SpaceBetween>

                            </SpaceBetween>
                        )}
                    </SpaceBetween>




                </>
            }
        />
    );
};
